//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/NXObject.js";
let d=[[],[[["numEngObjects","engObjects"],"ExecuteQuery",{},0,0],[["isPreview","numEngObjects","engObjects"],"ExecuteQuery1",{},1,0],[[],"ExecuteQuery2",{R_:{queryResult:"AME.QueryResult"}},0,0],[[],"ExecuteQueryWithTargetsWithoutLoading",{R_:{queryResult:"AME.QueryResult"}},0,0],[["removedClauses"],"RemoveClause",{},1,1],[["clauses"],"RemoveClauses",{},1,0],[["clauses"],"GroupClauses",{},1,0],[["clauses"],"UngroupClauses",{},1,0],[["referenceClause","clause"],"InsertClauseBefore",{},2,0],[["text"],"ModifySearchScope",{},1,0],[["isPreview"],"SetPreview",{},1,0],[[],"GetName",{R_:{text:''}},0,0],[["text"],"SetName",{},1,0],[[],"GetDescription",{R_:{text:''}},0,0],[["text"],"SetDescription",{},1,0]],[]];
SPLM.AME.AMEQuery = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AMEQuery";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;